import { render, staticRenderFns } from "./PolicyRenewalHelpList.vue?vue&type=template&id=5c2bf5fa&"
import script from "./PolicyRenewalHelpList.vue?vue&type=script&lang=js&"
export * from "./PolicyRenewalHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports